import { render, staticRenderFns } from "./DominioList.vue?vue&type=template&id=719a1994&scoped=true&"
import script from "./DominioList.vue?vue&type=script&lang=js&"
export * from "./DominioList.vue?vue&type=script&lang=js&"
import style0 from "./DominioList.vue?vue&type=style&index=0&id=719a1994&prod&lang=scss&scoped=true&"
import style1 from "./DominioList.vue?vue&type=style&index=1&id=719a1994&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719a1994",
  null
  
)

export default component.exports